<template>
  <div class="home">
    <div class="swiper-container1" id="swiper-container1">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div class="banner-img">
            <img src="@/assets/images/home/banner2.jpg" alt />
            <div class="banner-img-content banner-img-1">
              <h2>轻松建立无忧防御</h2>
              <p>抗D盾——基于云计算和大数据的协同防御</p>
              <div class="btn">
                <a @click="$router.push('/product')">点击查看</a>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="banner-img">
            <img src="@/assets/images/home/banner1.jpg" alt />
            <div class="banner-img-content banner-img-1"> 
              <h2>善守者藏于九地之下</h2>
              <p>安全性至上的集成服务 深度学习网络基础</p>
              <div class="btn">
                <a @click="$router.push('/product/xShield')">点击查看</a>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="banner-img">
            <img src="@/assets/images/home/banner3.jpg" alt />
            <div class="banner-img-content banner-img-2">
              <h2>CDN高度定制化</h2>
              <p>
                快速、安全、稳定多节点，智分发，解决
                <br />带宽、地域等实际问题
              </p>
              <div class="btn">
                <a @click="$router.push('/product/xunDispense')">点击查看</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-pagination1"></div>
    </div>

    <!-- 核心产品 -->
    <div class="core d_jump">
      <div class="common-title">
        <h2>核心产品</h2>
        <p>安全促发展，发展促安全</p>
      </div>
      <ul>
        <li v-for="(item, index) of coreArr" :key="index" class="index-hover-li">
          <img :src="item.src" alt />
          <div class="core-content-default">{{ item.title }}</div>
          <div class="core-content">
            <div class="core-content-title">{{ item.title }}</div>
            <div class="core-content-text">{{ item.text }}</div>
            <div class="bt" @click="goToCore(index)">前往查看</div>
          </div>
        </li>
      </ul>
    </div>

    <!-- 解决方案 -->
    <div class="solution d_jump">
      <div class="common-title">
        <h2>解决方案</h2>
        <p>
          安全有效的解决方案,涵盖电子商务解决方案,游戏行业解决方案
          <br />音视频解决方案等健全的解决方案
        </p>
      </div>
      <div class="solution-content">
        <div class="solution-nav">
          <ul>
            <li
              class="pointer"
              :style="{ background: index === solutionNavMark ? '#00A896' : '' }"
              @click="solutionNavClick(index)"
              v-for="(item, index) of solutionBtn"
              :key="index"
            >
              <div class="arrow" v-show="index === solutionNavMark"></div>
              <img :src="item.src" alt v-show="solutionNavMark !== index" />
              <img :src="item.srcSelected" alt v-show="solutionNavMark === index" />
              <span :style="{ color: index === solutionNavMark ? '#fff' : '' }">{{ item.label }}</span>
            </li>
          </ul>
        </div>
        <div class="content pr">
          <h3>{{ solutionContent[solutionNavMark].title }}</h3>
          <p>{{ solutionContent[solutionNavMark].text }}</p>
          <ul>
            <li v-for="(item, index) of solutionContent[solutionNavMark].list" :key="index">
              <span>{{ item }}</span>
            </li>
          </ul>
          <div class="bt" @click="goToSolution">前往查看</div>
          <div class="solution-img">
            <img :src="solutionContent[solutionNavMark].src" alt />
          </div>
        </div>
      </div>
    </div>

    <!-- 贴心服务 -->
    <div class="close d_jump">
      <div class="common-title">
        <h2>贴心服务</h2>
      </div>
      <div class="swiper-container-bg pr close-swiper">
        <div class="swiper-container pr" id="swiper-container2">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="left">
                <p class="title">等保2.0测评顾问，低成本完成安全整改，轻松满足等保合规要求</p>
                <p class="text">为用户提供“云平台等保备案证明”、“云测评报告关键页”，实现以较小的安全投入满足等保的基础合规要求，更有利于用户通过等级保护测评。</p>
                <div class="bt" @click="$router.push('/intimateServer/equalInsurance2')">查看详情</div>
              </div>
              <div class="img">
                <img src="@/assets/images/home/icon_cloud_list9-1@2x.png" alt />
              </div>
            </div>
            <div class="swiper-slide">
              <div class="left">
                <p class="title">网络攻防模拟环境的设计与实现---详解网络安全问题</p>
                <p class="text">网络攻防模拟平台是促进网络安全技术迅速发展的重要平台工具保护网络免受攻击,保障信息安全正成为研究的热点。</p>
                <div class="bt" @click="$router.push('/intimateServer/simulatedAttackAndDefense')">查看详情</div>
              </div>
              <div class="img">
                <img src="@/assets/images/home/icon_cloud_list9-2@2x.png" alt />
              </div>
            </div>
            <div class="swiper-slide">
              <div class="left">
                <p class="title">安全编码规范咨询、源代码安全现状测评、源代码整改咨询</p>
                <p class="text">源代码安全审计是以发现应用程序编码过程中造成的安全漏洞为目的，通过源代码静态分析工具，对已有的代码进行检测、分析</p>
                <div class="bt" @click="$router.push('/intimateServer/codeAudit')">查看详情</div>
              </div>
              <div class="img">
                <img src="@/assets/images/home/icon_cloud_list9-3@2x.png" alt />
              </div>
            </div>
            <div class="swiper-slide">
              <div class="left">
                <p class="title">Windows 入侵类问题排查思路，深入分析，查找入侵原因</p>
                <p
                  class="text"
                >查看服务器已有系统或应用帐户是否存在弱口令。检查说明：主要检查系统管理员帐户、网站后台帐户、数据库帐户以及其他应用程序帐户是否存在弱口令。</p>
                <div class="bt" @click="$router.push('/intimateServer/holeCheck')">查看详情</div>
              </div>
              <div class="img">
                <img src="@/assets/images/home/icon_cloud_list9-4@2x.png" alt />
              </div>
            </div>
            <div class="swiper-slide">
              <div class="left">
                <p class="title">7*24小时救援服务，全心为你提供全方位安全保障</p>
                <p class="text">7*24小时服务 包括标准兼容测试、专家兼容测试、手游安全测试、远程调试等多款产品，立体化安全防护体系，保卫您的信息安全。</p>
                <div class="bt" @click="$router.push('/intimateServer/rescue')">查看详情</div>
              </div>
              <div class="img">
                <img src="@/assets/images/home/icon_cloud_list9-5@2x.png" alt />
              </div>
            </div>
            <div class="swiper-slide">
              <div class="left">
                <p class="title">无感验证 有效提升客户体验，帮助企业优化认证流程</p>
                <p
                  class="text"
                >无感验证是现有短信验证方式的优化，通过应用层与网络层的技术特点设计，能消除现有短信验证模式等待时间长、操作繁琐、容易泄露等问题，有效提升客户体验，帮助企业优化认证流程</p>
                <div class="bt" @click="$router.push('/intimateServer/safetyVerification')">查看详情</div>
              </div>
              <div class="img">
                <img src="@/assets/images/home/icon_cloud_list9-6@2x.png" alt />
              </div>
            </div>
          </div>
          <div class="swiper-pagination care-pagination"></div>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div>
    </div>

    <!-- 合规支持 -->
    <!-- <compliance-support-common></compliance-support-common> -->

    <!-- 服务客户 -->
    <customer-server-common></customer-server-common>
  </div>
</template>

<script>
// import bus from "@/assets/js/bus";
import Swiper from "swiper";
export default {
  name: "officialIndex",
  components: {
    Swiper,
    customerServerCommon: () => import("@/components/customerServerCommon"),
    complianceSupportCommon: () =>
      import("@/components/complianceSupportCommon")
  },
  data() {
    return {
      solutionNavMark: 0,
      coreArr: [
        {
          active: false,
          src: require("../../assets/images/home/pic_hxcp01@2x.png"),
          title: "抗D盾（ddos防御）",
          text:
            "实时对云防御规则库优化和分发虚拟补丁程序，为WEB系统提供安全防御。"
        },
        {
          active: false,
          src: require("../../assets/images/home/pic_hxcp02@2x.png"),
          title: "CC无忧（CC防御）",
          text:
            "实时对云防御规则库优化和分发虚拟补丁程序，为WEB系统提供安全防御。"
        },
        {
          active: false,
          src: require("../../assets/images/home/pic_hxcp03@2x.png"),
          title: "CDN（web防火墙）",
          text:
            "实时对云防御规则库优化和分发虚拟补丁程序，为WEB系统提供安全防御。"
        }
      ],
      solutionContent: [
        {
          title: "金融行业安全解决方案/Financial Solutions",
          text:
            "金融行业解决方案为新金融行业提供量身定制的云计算服务，为金融行业客户量身定制合规安全、低成本、高性能、高可用的云服务，帮助金融客户实现从传统 IT 向云计算的转型。为使用者提供贴心服务。",
          list: ["金融解决方案", "贴心服务", "低成本、高性能"],
          src: require("../../assets/images/home/icon_cloud_list1.png")
        },
        {
          title: "游戏行业安全解决方案/Game Solution",
          text:
            "游戏公司通常容易受到DDoS攻击。依赖自定义TCP和UDP通信协议的游戏平台需要更多资源来防御DDoS攻击，使用讯游盾保护游戏服务器的正常运行。同时佰讯云依托丰富的游戏生态资源和能力。",
          list: ["防御DDoS攻击", "TCP和UDP通信协议", "游戏生态资源"],
          src: require("../../assets/images/home/icon_cloud_list2.png")
        },
        {
          title: "直播行业安全解决方案/Live Broadcast",
          text:
            "为直播行业提供完美的媒体体验是一项复杂性的工作，它不仅需要快速，不间断地传递内容，而且还需要保护媒体属性免受恶意流量的侵害。使用讯播盾为直播行业能够以轻松地享受安全，快速和可靠的服务体验。",
          list: ["攻击防护", "高速响应", "稳定可用"],
          src: require("../../assets/images/home/icon_cloud_list3.png")
        },
        {
          title: "电商行业安全解决方案/E-commerce",
          text:
            "为电商行业提供稳定贴心的解决方案，电商行业存在大量的媒体素材以及交易相关数据，分秒必争。使用讯商盾能够提升用户体验并助力提升营收。确保正常运行时间和可靠性，快速部署对接，降低运营成本。",
          list: ["助力提升营收", "快速部署对接", "降低运营成本"],
          src: require("../../assets/images/home/icon_cloud_list4.png")
        },
        {
          title: "教育行业安全解决方案/Educational",
          text:
            "黑客利用恶意篡改、代码植入、DDoS大流量攻击、爬虫等方式，对高考查分网站、志愿填报网站、大学官网、在线教育网站进行攻击，教育类网站面临严峻安全挑战。",
          list: ["篡改植入", "DDoS大流量攻击", "爬虫攻击"],
          src: require("../../assets/images/home/icon_cloud_list5.png")
        },
        {
          title: "媒体行业安全解决方案/Media Solutions",
          text:
            "对媒体行业而言，门户网站是最易受到攻击的地方。常见的攻击方式有网页篡改、挂马和被植入暗链等。门户网站作为新闻媒体对外的第一扇门，通常承载了大量的流量，一旦遭到攻击，造成的影响会更具有可怕的“传播力”。",
          list: ["提升“传播力”", "高效的安全体系", "全方位安全体系"],
          src: require("../../assets/images/home/icon_cloud_list6.png")
        }
      ],
      solutionBtn: [
        {
          label: "金融解决方案",
          src: require("../../assets/images/home/ico_jr0@2x.png"),
          srcSelected: require("../../assets/images/home/ico_jr1@2x.png")
        },
        {
          label: "游戏解决方案",
          src: require("../../assets/images/home/ico_yx0@2x.png"),
          srcSelected: require("../../assets/images/home/ico_yx1@2x.png")
        },
        {
          label: "直播解决方案",
          src: require("../../assets/images/home/ico_zb0@2x.png"),
          srcSelected: require("../../assets/images/home/ico_zb1@2x.png")
        },
        {
          label: "电商解决方案",
          src: require("../../assets/images/home/ico_ds0@2x.png"),
          srcSelected: require("../../assets/images/home/ico_ds1@2x.png")
        },
        {
          label: "教育解决方案",
          src: require("../../assets/images/home/ico_jy0@2x.png"),
          srcSelected: require("../../assets/images/home/ico_jy1@2x.png")
        },
        {
          label: "媒体解决方案",
          src: require("../../assets/images/home/ico_mt0@2x.png"),
          srcSelected: require("../../assets/images/home/ico_mt1@2x.png")
        }
      ]
    };
  },
  methods: {
    solutionNavClick(ind) {
      this.solutionNavMark = ind;
    },
    goTo(path) {
      this.$router.push(path);
    },
    goToSolution() {
      switch (this.solutionNavMark) {
        case 0:
          this.goTo("/solution");
          break;
        case 1:
          this.goTo("/solution/gameSolution");
          break;
        case 2:
          this.goTo("/solution/broadcastSolution");
          break;
        case 3:
          this.goTo("/solution/shopSolution");
          break;
        case 4:
          this.goTo("/solution/educationSolution");
          break;
        case 5:
          this.goTo("/solution/newsSolution");
          break;

        default:
          break;
      }
    },
    goToCore(ind) {
      switch (ind) {
        case 0:
          this.goTo("/product");
          break;
        case 1:
          this.goTo("/product/ccWorry");
          break;
        case 2:
          this.goTo("/product/xShield");
          break;

        default:
          break;
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    window.scrollTo(0, 0);
    next();
  },
  mounted() {
    let mySwiper1 = new Swiper("#swiper-container1", {
      speed: 1000,
      pagination: {
        el: ".swiper-pagination1",
        clickable: true
      },
      autoplay: {
        delay: 2500,
        disableOnInteraction: false
      },
      loop: true
    });
    let mySwiper2 = new Swiper("#swiper-container2", {
      // mousewheel: true,   // 鼠标滚轮
      speed: 1000,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
        hideOnClick: true
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function(index, className) {
          var text = "";
          switch (index) {
            case 0:
              text = "等保2.0测评顾问";
              break;
            case 1:
              text = "模拟攻防";
              break;
            case 2:
              text = "代码审计";
              break;
            case 3:
              text = "漏洞排查";
              break;
            case 4:
              text = "7*24小时救援";
              break;
            case 5:
              text = "安全验证";
              break;
            default:
              break;
          }
          return '<li class="' + className + '">' + text + "</li>";
        }
      },
      autoplay: {
        delay: 2500,
        disableOnInteraction: false
      },
      loop: true
    });

    mySwiper1.el.onmouseover = function () {
      mySwiper1.autoplay.stop()
    }
    mySwiper1.el.onmouseleave = function () {
      mySwiper1.autoplay.start()
    }

    mySwiper2.el.onmouseover = function () {
      mySwiper2.autoplay.stop()
    }
    mySwiper2.el.onmouseleave = function () {
      mySwiper2.autoplay.start()
    }

    // bus.$on("indexJump", index => {
    //   this.jump(index);
    // });
  }
};
</script>

<style lang="scss">
.care-pagination{
  height: 30px!important;
}
.close-swiper {
  .swiper-pagination {
    position: absolute;
    top: 50px;
    font-size: 18px;
  }
  .swiper-container-horizontal
    > .swiper-pagination-bullets
    .swiper-pagination-bullet {
    margin: 0;
    color: #5bfded;
    border-right: 1px solid #5bfded;
    &:last-child {
      border-right: none;
    }
  }
  .swiper-pagination-bullet {
    width: 100px;
    height: 30px;
    background-color: #00a896;
    border-radius: 0;
    opacity: 1;
    color: #fff;
    &:first-child {
      width: 164px;
    }
    &:nth-child(5) {
      width: 142px;
    }
  }
  .swiper-pagination-bullet-active {
    color: #fff !important;
  }
}
</style>

<style lang="scss" scoped>
@import "./index.scss";
</style>
